const sessionStorageKey = {
  policy: 'policy',
  session: 'session',
  customer: 'customer',
  documents: 'documents',
  vehicles: 'vehicles',
  step: 'step',
  content: 'content',
  products: 'products',
};
export default sessionStorageKey;
